import React, { useEffect, useState } from "react";
import Index from "../../Index";
import { QRCodeCanvas } from "qrcode.react";
import PagesIndex from "../../PagesIndex";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WalletLoader from "../../../components/common/WalletLoader";
const QrGenerate = ({
  openQrModal,
  setOpenQrModal,
  amount,
  hashValue,
  setHashValue,
  networkName,
  setLoading,
  walletAddress,
  handleBuyToken,
  btnLoading,
  setBtnLoading,
}) => {
  const handleClose = () => {
    setOpenQrModal(false);
    setLoading(false);
    setBuy(false);
    setBtnLoading(false);
    setQrValue("");
    setHashValue("")
  };
  const [buy, setBuy] = useState(false);
  const [qrValue, setQrValue] = useState("");

  const createQRCodeValue = () => {
    let uri;
    if (networkName === "SOL") {
      uri = `solana:${walletAddress}?amount=${amount}`;
    } else if (networkName === "ADA") {
      uri = `web+cardano:${walletAddress}?amount=${amount}`;
    } else if (networkName === "XRP") {
      uri = `ripple:${walletAddress}?amount=${amount}`;
    } else {
      uri = "";
    }

    setQrValue(uri);
  };
  console.log({ qrValue });

  useEffect(() => {
    if (openQrModal) {
      createQRCodeValue();
    }
  }, [openQrModal]);

  const handleAddressCopy = (address) => {
    if (address) {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          alert(`Address copied successfully`);
        })
        .catch((err) => {
          alert("Failed to copy");
        });
    }
  };

  return (
    <Index.Modal
      className="cus-main-modal"
      open={openQrModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Index.Box className="cus-qr-modal">
        {/* <Index.Box className="cus-qr-header">
        </Index.Box> */}
        <Index.Box className="cus-qr-header">
          <Index.Box className="generate-qr-close-div">
            <CloseIcon
              fontSize="small"
              className="generate-qr-close"
              onClick={handleClose}
            />
          </Index.Box>
          <Index.Typography className="generate-qr-code-title">
            Scan QR Code
          </Index.Typography>
        </Index.Box>
        <Index.Box className="svg-box-cont">
          <QRCodeCanvas value={qrValue} size={180} />
        </Index.Box>
        <Index.Box>
          <Index.Typography className="amount-qr-title">{`Amount : ${
            Number(amount)
              ?.toFixed(6)
              ?.replace(/\.?0+$/, "") || 0
          } ${networkName}`}</Index.Typography>
          {/* <Index.Typography className="amount-qr-title">{`Network : ${networkName}`}</Index.Typography> */}
        </Index.Box>
        <Index.Box>
          <Index.Typography className="amount-qr-wallet">
            {walletAddress}
            <Index.Link
              className="copy-icon-box"
              onClick={() => handleAddressCopy(walletAddress)}
            >
              {" "}
              <img src={PagesIndex.Svg.Copy} alt="Copy Icon" />{" "}
            </Index.Link>
          </Index.Typography>
        </Index.Box>
        {buy ? (
          <Index.Box className="btc-modal-confirm-box">
            <Index.TextField
              size="small"
              fullWidth
              placeholder="Enter transaction hash"
              className="confirm-input"
              onChange={(e) => {
                setHashValue(e.target.value);
              }}
            />
            <Index.Box className="header-box">
              <Index.Box
                className="header-menu-box confirm-btn-box center-btn"
                sx={{ justifyContent: "center" }}
              >
                <Index.Button
                  onClick={() => {
                    handleBuyToken(hashValue);
                    setBtnLoading(true);
                  }}
                  className="header-link-btn confirm-btn"
                  disabled={!hashValue || btnLoading}
                >
                  {btnLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Confirm"
                  )}
                </Index.Button>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        ) : (
          <Index.Box className="header-box">
            <Index.Box
              className="header-menu-box confirm-btn-box center-btn"
              sx={{ justifyContent: "center" }}
            >
              <Index.Button
                className="header-link-btn confirm-btn"
                onClick={() => setBuy(true)}
              >
                Continue
              </Index.Button>
            </Index.Box>
          </Index.Box>
        )}
        {!qrValue && (
          <div className="wallet-loader">
            <WalletLoader />
          </div>
        )}
      </Index.Box>
    </Index.Modal>
  );
};

export default QrGenerate;
